import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ERouterName } from '/@/types/index'

const WaylinePanel = () => import('/@/pages/page-web/projects/wayline.vue')
const CreatePlan = () => import('/@/components/task/CreatePlan.vue')
const DockPanel = () => import('/@/pages/page-web/projects/dock.vue')
const LiveAgora = () => import('/@/components/livestream-agora.vue')
const LiveOthers = () => import('/@/components/livestream-others.vue')

/** 通配 404；登录后会在 permission 里 remove + 在动态路由之后再次 add，保证刷新业务路径时先匹配动态路由 */
export const notFoundRoute: RouteRecordRaw = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: () => import('/@/pages/page-web/404.vue'),
  meta: { title: '页面不存在' }
}

// 静态路由
export const constantRoutes: Array<RouteRecordRaw> = [
  {
    path: '/404',
    name: '404',
    component: () => import('/@/pages/page-web/404.vue')
  },
  {
    path: '/',
    redirect: '/' + ERouterName.PROJECT
  },
  // 登录
  {
    path: '/' + ERouterName.PROJECT,
    name: ERouterName.PROJECT,
    component: () => import('/@/pages/page-web/index.vue')
  },
  // 免登录
  // {
  //   path: '/' + ERouterName.FREE_LOGIN,
  //   name: ERouterName.FREE_LOGIN,
  //   component: () => import('/@/pages/page-web/freeLogin.vue')
  // },
  // 大屏
  {
    path: '/' + ERouterName.LARGE_SCREEN,
    name: ERouterName.LARGE_SCREEN,
    component: () => import('/@/pages/page-web/largeScreen.vue')

  },
  // HC 大屏（term 机器人详情三栏）
  {
    path: '/' + ERouterName.HC_SCREEN,
    name: ERouterName.HC_SCREEN,
    component: () => import('/@/pages/page-web/hcScreen.vue'),
  },
  // 中程迭代MVP
  {
    path: '/' + ERouterName.GROUND_AIR,
    name: ERouterName.GROUND_AIR,
    component: () => import('/@/pages/page-web/groundAir.vue')
  },
  // 产品展示页
  {
    path: '/' + ERouterName.PRODUCT,
    name: ERouterName.PRODUCT,
    component: () => import('/@/pages/page-web/product.vue')
  },
  // 仓储监控
  {
    path: '/' + ERouterName.WAREHOUSE_MONITOR,
    name: ERouterName.WAREHOUSE_MONITOR,
    component: () => import('/@/pages/page-web/robots/warehouseMonitor.vue')
  },
  // pilot
  {
    path: '/' + ERouterName.PILOT,
    name: ERouterName.PILOT,
    component: () => import('/@/pages/page-pilot/pilot-index.vue'),
  },
  {
    path: '/' + ERouterName.PILOT_HOME,
    component: () => import('/@/pages/page-pilot/pilot-home.vue')
  },
  {
    path: '/' + ERouterName.PILOT_MEDIA,
    component: () => import('/@/pages/page-pilot/pilot-media.vue')
  },
  {
    path: '/' + ERouterName.PILOT_LIVESHARE,
    component: () => import('/@/pages/page-pilot/pilot-liveshare.vue')
  },
  {
    path: '/' + ERouterName.PILOT_BIND,
    component: () => import('/@/pages/page-pilot/pilot-bind.vue')
  },
  // 独立 H5 页面（无 Topbar/Sidebar，适合移动端）
  {
    path: '/' + ERouterName.SONG_LIST,
    name: ERouterName.SONG_LIST,
    component: () => import('/@/pages/song-list/index.vue'),
    meta: { title: 'H5页面', noLayout: true }
  },
  // 机器人弹钢琴
  {
    path: '/' + ERouterName.ROBOT_PIANO,
    name: ERouterName.ROBOT_PIANO,
    component: () => import('/@/pages/page-web/robots/robot-piano/index.vue'),
  },
  // 智能仓储（挂在机器人管控中心布局下，左侧为智能仓储专用菜单）
  {
    path: '/' + ERouterName.SMART_WAREHOUSE,
    name: ERouterName.SMART_WAREHOUSE,
    component: () => import('/@/pages/page-web/robotHome.vue'),
    redirect: '/' + ERouterName.SMART_WAREHOUSE_JOB_OVERVIEW,
    children: [
      {
        path: '/' + ERouterName.SMART_WAREHOUSE_JOB_OVERVIEW,
        name: ERouterName.SMART_WAREHOUSE_JOB_OVERVIEW,
        component: () => import('../pages/page-web/robots/warehouse/jobOverview.vue'),
        meta: { title: '作业总览' },
      },
      {
        path: '/' + ERouterName.SMART_WAREHOUSE_DISPATCH,
        name: ERouterName.SMART_WAREHOUSE_DISPATCH,
        component: () => import('../pages/page-web/robots/warehouse/dispatch.vue'),
        meta: { title: '模拟派单' },
      },
      {
        path: '/' + ERouterName.SMART_WAREHOUSE_TASK_LIST,
        name: ERouterName.SMART_WAREHOUSE_TASK_LIST,
        component: () => import('../pages/page-web/robots/warehouse/taskList.vue'),
        meta: { title: '任务列表' },
      },
      {
        path: '/' + ERouterName.SMART_WAREHOUSE_TASK_LIST + '/:taskNo',
        name: ERouterName.SMART_WAREHOUSE_TASK_DETAIL,
        component: () => import('/@/pages/page-web/robots/warehouse/taskDetail.vue'),
        meta: { title: '任务详情' },
      },
      {
        path: '/' + ERouterName.SMART_WAREHOUSE_STATION_LIST,
        name: ERouterName.SMART_WAREHOUSE_STATION_LIST,
        component: () => import('../pages/page-web/robots/warehouse/stationList.vue'),
        meta: { title: '工位列表' },
      },
      {
        path: '/' + ERouterName.SMART_WAREHOUSE_DEVICE,
        name: ERouterName.SMART_WAREHOUSE_DEVICE,
        component: () => import('../pages/page-web/robots/warehouse/device.vue'),
        meta: { title: '设备管理' },
      },
      {
        path: '/' + ERouterName.SMART_WAREHOUSE_MATERIAL_LIB,
        name: ERouterName.SMART_WAREHOUSE_MATERIAL_LIB,
        component: () => import('../pages/page-web/robots/warehouse/materialLib.vue'),
        meta: { title: '商品电子库' },
      },
    ],
  },
]

/**
 * 创建路由
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: constantRoutes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 }),
})

// 处理发布后动态分片 hash 变化导致的懒加载失败，首次命中时自动刷新一次。
const DYNAMIC_IMPORT_RETRY_KEY = '__dynamic_import_retry__'
router.onError((error) => {
  const message = (error as Error)?.message || ''
  const isDynamicImportError =
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Importing a module script failed')

  if (!isDynamicImportError) return

  const hasRetried = sessionStorage.getItem(DYNAMIC_IMPORT_RETRY_KEY) === '1'
  if (hasRetried) return

  sessionStorage.setItem(DYNAMIC_IMPORT_RETRY_KEY, '1')
  const currentUrl = new URL(window.location.href)
  currentUrl.searchParams.set('_v', Date.now().toString())
  window.location.replace(currentUrl.toString())
})

router.addRoute(notFoundRoute)

/**
 * 重置路由
 */
export function resetRouter () {
  router.replace({ path: `/${ERouterName.PROJECT}` })
}

export default router
